let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("blxz1")).then(() => parcelRequire('7sYTD'));